var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTransactionForsale = function SvgIconTransactionForsale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    fillRule: "evenodd",
    d: "m12.192 2.034 3.785 3.768a4.61 4.61 0 0 1-.001 6.508l-3.659 3.658v.001a4.61 4.61 0 0 1-6.509 0l-3.775-3.776A4.63 4.63 0 0 1 .684 8.715v-.002l.2-4.168A3.845 3.845 0 0 1 4.554.893h.002l4.162-.2h.001a4.59 4.59 0 0 1 3.473 1.341m-.884.884a3.33 3.33 0 0 0-2.525-.976H8.78l-4.166.2h-.002a2.595 2.595 0 0 0-2.48 2.465L1.934 8.77c-.042.95.317 1.87.984 2.538l3.775 3.775a3.36 3.36 0 0 0 4.742 0l3.658-3.658a3.36 3.36 0 0 0-.002-4.742l-3.78-3.765z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    fillRule: "evenodd",
    d: "M6.917 5.46a1.458 1.458 0 1 0 0 2.918 1.458 1.458 0 0 0 0-2.917M4.21 6.92a2.708 2.708 0 1 1 5.417 0 2.708 2.708 0 0 1-5.417 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconTransactionForsale;